import './style.css'
import * as THREE from 'three'

function base58to10(x) {
    switch (x) {
      case "1":
        return 1
      case "2":
        return 2
      case "3":
        return 3
      case "4":
        return 4
      case "5":
        return 5
      case "6":
        return 6
      case "7":
        return 7
      case "8":
        return 8
      case "9":
        return 9
      case "A":
        return 10
      case "B":
        return 11
      case "C":
        return 12
      case "D":
        return 13
      case "E":
        return 14
      case "F":
        return 15
      case "G":
        return 16
      case "H":
        return 17
      case "J":
        return 18
      case "K":
        return 19
      case "L":
        return 20
      case "M":
        return 21
      case "N":
        return 22
      case "P":
        return 23
      case "Q":
        return 24
      case "R":
        return 25
      case "S":
        return 26
      case "T":
        return 27
      case "U":
        return 28
      case "V":
        return 29
      case "W":
        return 30
      case "X":
        return 31
      case "Y":
        return 32
      case "Z":
        return 33
      case "a":
        return 34
      case "b":
        return 35
      case "c":
        return 36
      case "d":
        return 37
      case "e":
        return 38
      case "f":
        return 39
      case "g":
        return 40
      case "h":
        return 41
      case "i":
        return 42
      case "j":
        return 43
      case "k":
        return 44
      case "m":
        return 45
      case "n":
        return 46
      case "o":
        return 47
      case "p":
        return 48
      case "q":
        return 49
      case "r":
        return 50
      case "s":
        return 51
      case "t":
        return 52
      case "u":
        return 53
      case "v":
        return 54
      case "w":
        return 55
      case "x":
        return 56
      case "y":
        return 57
      case "z":
        return 58
    }
}
console.log(fxhash)
var seed = fxhash.split("")
var converted = []
for (let i = 0; i < seed.length; i++) {
converted.push(base58to10(seed[i]))
}


console.log(converted)

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Sizes
 */
 const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()

//GREEN
const greenTexture = textureLoader.load(converted[2] < 26 ? 'textures/matcaps/' + converted[2].toString() + '.png' : 'textures/matcaps/1.png')
const greenMatcap = new THREE.MeshMatcapMaterial({ matcap: greenTexture })

//PURPLE
const purpleTexture = textureLoader.load(converted[3] < 26 ? 'textures/matcaps/' + converted[3].toString() + '.png' : 'textures/matcaps/3.png')
const purpleMatcap = new THREE.MeshMatcapMaterial({ matcap: purpleTexture })

//BLACK
const blackTexture = textureLoader.load(converted[4] < 26 ? 'textures/matcaps/' + converted[4].toString() + '.png' : 'textures/matcaps/0.png')
const blackMatcap = new THREE.MeshMatcapMaterial({ matcap: blackTexture })

//PINK
const pinkTexture = textureLoader.load(converted[5] < 26 ? 'textures/matcaps/' + converted[5].toString() + '.png' : 'textures/matcaps/2.png')
const pinkMatcap = new THREE.MeshMatcapMaterial({ matcap: pinkTexture })

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(100, sizes.width / sizes.height, 1, 100)
camera.position.y = 16
camera.position.x = -(16 * 1.1 + 0.5)
camera.position.z = 20
scene.add(camera)

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/*
 * IMAGE DATA
 */
var colourConfig = [
  "00000000000222222222222222222222",
  "00000000000000000000000222222222",
  "22222222000001111111100000000000",
  "22222222222111111111111000000000",
  "00002222221111111111111222222200",
  "00000000001111111111111122222222",
  "00000000011111111111111100022222",
  "22222222211111111111111110000000",
  "22222222211100001111111110000000",
  "00002222211222000011111112222222",
  "00000000012222220001111112222222",
  "22220000012222222201111110000002",
  "22222222212222222221111110000000",
  "02222222333333333331111112200000",
  "00000000312131213221111112222222",
  "00000000321333123221111112222222",
  "22222222333323333221111110000000",
  "22222222122222222221111110000000",
  "00002222212000022211111112222220",
  "00000000012222222111111112222222",
  "20000001111222211111111111022222",
  "22222211111111111111111111100000",
  "22222111111111111111111111110000",
  "00001111111111111111111111112222",
  "00011111111111111111111111111222",
  "22211111111011111111111111111002",
  "22111111110111111111111111111100",
  "22111111110111111111111111111100",
  "00111111101111111111101111111122",
  "01111111111111111111101111111112",
  "21111111111111111111101111111110",
  "21111111111111111111101111111110"
]
var imageString = ""
for(let i = 0; i < colourConfig.length; i++) {
  imageString += colourConfig[i]
}

imageString = imageString.split("").reverse()

var cubes = []

const geometries = [
  new THREE.BoxGeometry( 1, 1, 1 ),
  new THREE.ConeGeometry( 0.5, 1, 32 ),
  new THREE.CylinderGeometry( 0.5, 0.5, 1, 32 ),
  new THREE.DodecahedronGeometry(0.5, 0),
  new THREE.OctahedronGeometry(0.5, 0),
  new THREE.TorusKnotGeometry( 0.5, 0.1, 190, 7, 6, 14 ),
  new THREE.TorusKnotGeometry( 0.5, 0.1, 15, 7, 6, 14 ),
  new THREE.TorusKnotGeometry( 1, 0.1, 3, 3 )
]

for(let y = 0; y < 32; y++) {
  for(let x = 0; x < 32; x++) {
    let cube
    let geo = geometries[0]
    let mat
    // MATERIALS
    switch(imageString[x + y * 32]) {
      case "0":
        mat = greenMatcap
        break
      case "1":
        mat = blackMatcap
        break
      case "2":
        mat = purpleMatcap
        break
      case "3":
        mat = pinkMatcap
        break
    }
    switch(converted[20]) {
      case 10:
        geo = geometries[1]
        break
      case 11:
        geo = geometries[2]
        break
      case 12:
        geo = geometries[3]
        break
      case 13:
        geo = geometries[4]
        break
      case 14:
        geo = geometries[5]
        break
      case 15:
        geo = geometries[6]
        break
      case 16:
        geo = geometries[7]
        break
      case 19:
        geo = geometries[(x ^ y) % geometries.length]
        break
    }
    
    cube = new THREE.Mesh( geo, mat )
    cube.rotation.x = ((x ^ y) % converted[19])
    cube.rotation.y = ((x + y) % converted[19])
    cube.position.x = -(x * 1.1)
    cube.position.y = y * 1.1
    cubes.push(cube)
    scene.add(cubes[x + y * 32])
  }
}

/**
 * Init
 */

const init = () => {
    tick()
}


/**
 * Animate
 */

const clock = new THREE.Clock()
var timer = 0

const tick = () => {
    const elapsedTime = clock.getElapsedTime() 

    for(let i = 0; i < cubes.length; i++) {
      cubes[i].rotation.z += 0.01
      cubes[i].scale.set(
        (converted[2] > 30 ? Math.abs(Math.sin(elapsedTime)) + 0.5 : 1), 
        (converted[3] > 30 ? Math.abs(Math.sin(elapsedTime)) + 0.5 : 1), 
        (converted[4] > 30 ? Math.abs(Math.sin(elapsedTime)) + 0.5 : 1)
      )
    }

    if(timer > 100) {
      fxpreview()
    }
    timer++

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

window.onload = () => {init()}